// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"Tos_PageTitle___c6CX","TosDate":"Tos_TosDate__YfhaG","PageContainer":"Tos_PageContainer__SQfvR","TosContainer":"Tos_TosContainer__LvulT"};